<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

import { IApp, ISiteGroup, ICarnegoUser } from '../main';
import { IShimmyPage, get_shimmy_pages_for_project } from '@/views/ShimmyPlus/ShimmyPlus.vue';

import { carnego_theme, ventive_theme } from '@/plugins/vuetify';

const portfolioSet = new Set<string>();
portfolioSet.add('yosemite.engie.engie_sutton');
portfolioSet.add('yosemite.wales and west housing.bryn_bragl');
portfolioSet.add('yosemite.melius.melius_nch_keswick');
portfolioSet.add('yosemite.melius.melius_nch_camden');

export const performanceSet = new Set<string>();
// portfolioMap.add('yosemite.engie.engie_sutton');
performanceSet.add('yosemite.wales and west housing.bryn_bragl');
// portfolioMap.add('yosemite.melius.melius_nch_keswick');
// portfolioMap.add('yosemite.melius.melius_nch_camden');



@Component({
  components: {},
})
export default class Layout extends Vue {

  public numberOfShimmyPages: number = 0;
  public shimmyPages: IShimmyPage[] = [];
  public site_groups: ISiteGroup[] = [];

  public closeDrawer(): void {

  }

  public userinfo: ICarnegoUser = {
    username: '',
    email: '',
    fullname: '',
    is_superuser: false,
    house_name: '',
    street_name: '',
    postcode: '',
    attributes: {
      apps: [],
      avatar: '',
      filters: [],
      sitegroups: [],
      user_type: '',
    },
  };

  private authenticated: boolean = false;
  private git_version: string = '1.0';

  public get theme() {
    return (this.$vuetify.theme.dark) ? 'dark' : 'light';
  }

  public set theme(val: any) {
    this.$vuetify.theme.themes.light = val;
  }

  public async mounted() {
    const self = this;

    debugger;

    if (this.$store.getters.isAuthenticated) {
        self.userinfo = await this.$store.cache.dispatch('requestUserInfo');

        if (self.userinfo === null) {
          return;
        }
    }

    self.setUp();

    console.log('mounted DefaultLayout');
  }

  public async updated() {

    const self = this;

    console.log('updated DefaultLayout');
  }

  public async setAuthenticated(status: any) {
    this.authenticated = status;
  }

  public logout() {
    this.authenticated = false;
    this.$store.commit('clearCurrentSiteGroup');
    this.$store.dispatch('logOut');
    this.$router.replace({ path: '/login' });
  }

  protected get CurrentSiteGroup() {
    return this.$store.getters.CurrentSiteGroup;
  }

  public userHasApp(app: string): boolean {
    const self = this;

    if (self.userinfo === null) {
      return false;
    }

    const userAttributes = self.userinfo.attributes as { apps?: string[] };

    if (!userAttributes || !userAttributes.apps) {
      return false;
    }

    return userAttributes.apps.includes(app);
  }

  public siteHasPortfolio(): boolean {
    if (this.userinfo === null) {
      return false;
    }

    const userAttributes = this.userinfo.attributes as {
      sitegroups?: { namespace: string; server: string }[];
    };

    if (!userAttributes || !userAttributes.sitegroups) {
      return false;
    }

    const userSiteGroups = userAttributes.sitegroups.map((group) => group.namespace);

    return userSiteGroups.some((namespace) => portfolioSet.has(namespace));
  }
  
  // Getter to retrieve the avatar value
  get avatar(): string | undefined {
    if (this.userinfo && this.userinfo.attributes) {
      return this.userinfo.attributes.avatar;
    }
    return undefined;
  }

  get usertype(): string | undefined {
    if (this.userinfo && this.userinfo.attributes) {
      return this.userinfo.attributes.user_type;
    }
    return undefined;
  }
  protected siteHasPerformance(): boolean {
    if (this.userinfo === null) {
      return false;
    }

    const userAttributes = this.userinfo.attributes as { sitegroups?: { site_group_namespace: string }[] };

    if (!userAttributes || !userAttributes.sitegroups) {
      return false;
    }

    const userSiteGroups = userAttributes.sitegroups.map((group) => group.site_group_namespace);

    return userSiteGroups.some((namespace) => performanceSet.has(namespace));
  }

  protected getUserShimmyPages() {

    const self = this;

    self.numberOfShimmyPages = 0;

    if (self.userinfo === null) {
      return [];
    }

    if (self.CurrentSiteGroup === undefined || self.CurrentSiteGroup.namespace === undefined) {
      return [];
    }

    self.shimmyPages = get_shimmy_pages_for_project(self.CurrentSiteGroup.namespace.toLowerCase());
  }


  // userprojectinfo

  protected async setUp(site_group?: ISiteGroup) {

    const self = this;

    let current_site_group = self.$store.getters.CurrentSiteGroup;
    let jwt = self.$store.getters.Jwt;

    console.log("here1", site_group);

    if (site_group === undefined) {
      // If current_site_group is not defined, check if the user is a superuser
      if (self.userinfo && self.userinfo.is_superuser) {

        console.log("here2");

        try {
          // Make API call to get site groups for superuser
          const headers = {
            'Content-Type': 'text/plain',
            'authorization': 'BEARER authToken=' + jwt,
          };

          const response = await axios.get(window.VUE_APP_AUTH + '/api/userprojectinfo?project_name=carnego', {
            headers: headers,
          });

          const groups = response.data.carnego.settings.site_groups;

          console.log("groups", groups);

          // Ensure the response data is an object and has the 'sitegroups' property
          if (response.data && Array.isArray(groups)) {

            // Store the site groups in Vuex
            self.$store.commit('setSiteGroups', groups);
            self.site_groups = groups;

            // Set the default current site group to the first one in the list
            current_site_group = groups[0];

            console.log("current_site_group", current_site_group);

          }

        } catch (error) {
          console.error('Error fetching site groups for superuser:', error);
          // Handle error if necessary
        }
      } else {
        const userAttributes = self.userinfo.attributes as { sitegroups?: ISiteGroup[] };

        if (userAttributes && Array.isArray(userAttributes.sitegroups)) {
          const groups = userAttributes.sitegroups;

          // Store the site groups in Vuex
          self.$store.commit('setSiteGroups', groups);

          // Set the default current site group to the first one in the list
          current_site_group = groups[0];
        }
      }

      // Set the current site group in Vuex
      console.log("Done", current_site_group);
      self.$store.commit('setCurrentSiteGroup', current_site_group);
      return;
    }

    console.log("here1.5", current_site_group, site_group);

    if (current_site_group === site_group) {
      console.log("site_group not changing");
      return;
    }

    self.$store.commit('setCurrentSiteGroup', site_group);
  }

  public changeSiteGroup(newValue: ISiteGroup, oldValue: ISiteGroup): any {
    console.log("newValue", newValue);
    this.setUp(newValue);
  }
}
</script>

<style lang="less">

</style>
